


















































































































































import { Component, Watch } from "vue-property-decorator";

import NewsTicker from "../../components/features/NewsTicker.vue";
import DeviceType from "../../utils/DeviceUtil";
import videoDirective from "./positioning-directives/video-directive";
import battleRoom from "./positioning-directives/battle-room-directive";
import workshops from "./positioning-directives/workshops-directive";
import booths from "./positioning-directives/booths-directive";
import infoDesk from "./positioning-directives/info-desk-directive";
import titleFlag from "./positioning-directives/title-flag-directive";
import mobileWidget from "./positioning-directives/mobile-widget-directive";
import {
  getSawVideoTutorial,
  setSawVideoTutorial,
} from "../../utils/VideoTutorialUtil";
import { mixins } from "vue-class-component";
import { Getter } from "vuex-class";
import { LocalizableField } from "../../models/LocalizableField";
import UserManual from "./UserManual.vue";
import { Route } from "vue-router";
@Component({
  directives: {
    videoDirective,
    battleRoom,
    workshops,
    booths,
    infoDesk,
    titleFlag,
    mobileWidget,
  },
  components: {
    NewsTicker,
    UserManual,
  },
})
export default class HomePage extends mixins(DeviceType) {
  private showUserManual = false;
  private player: any;
  private isMute = true;
  mounted() {
    this.player = this.$refs.sound as any;
  }
  @Getter("eventTitle") private eventTitle!: string;
  @Getter("userManualEnabled") private userManualEnabled!: boolean;
  created() {
    this.$store.dispatch("fetchSystemSettings");
    this.showUserManual = !getSawVideoTutorial();
  }

  public get screenValues(): {
    height: number;
    width: number;
  } {
    if (this.isMobile || this.isTablet) {
      return {
        width: this.windowWidth * 0.4,
        height: this.windowWidth * 0.4,
      };
    }
    return {
      height: this.windowWidth * 0.45,
      width: window.innerWidth,
    };
  }

  beforeRouteEnter(to: Route, from: Route, next: CallableFunction) {
    if (window.innerWidth < 768 && !getSawVideoTutorial()) {
      next("/user_manual");
    } else {
      next();
    }
  }

  startVideoTutorial() {
    this.showUserManual = true;
    this.player.pause();
    this.isMute = !this.isMute;
    (this.$refs.userManualComponent as any).play();
  }
  controlBackgroundVideoSound() {
    if (this.isMute) {
      this.player.play();
    } else {
      this.player.pause();
    }

    this.isMute = !this.isMute;
  }
}
